<template>
  <div class="casesPage">
    <head-top></head-top>
    <div class="banner">
      <h3>电商系统</h3>
      <p>商鼎云持续在电商领域深耕</p>
    </div>
    <div class="casesNav">
      <ul>
        <li :class="{'current':type == 1000}" @click="type = 1000;getFilter()">全部</li>
        <li :class="{'current':type == 1201}" @click="type = 1201;getFilter()">电商模板</li>
        <li :class="{'current':type == 1301}" @click="type = 1301;getFilter()">客户案例</li>
      </ul>
    </div>
    <div class="casesListBox">
      <div class="casesList" v-for="(item,index) of casesList" :key="index" :class="{'backstage':item.casesType == 1501}">
        <div class="pageCenter">
          <div class="casesInfo">
            <div class="casesLogoName">
              <div class="casesLogo" v-if="item.logo">
                <img :src="item.logo">
              </div>
              <div class="name">
                <h3>{{item.name}}</h3>
                <p>{{item.industry}}</p>
              </div>
              <button class="deep" @click="detailsJump(item)">查看详情</button>
            </div>
            <div class="description">
              {{item.description}}
            </div>
            <div class="but">
              <button class="shallow" v-if="item.preview.length > 0">体验一下
                <div class="code">
                  <span class="arrow"></span>
                  <div v-for="(childItem,childIndex) of item.preview" :key="childIndex">
                    <img :src="childItem.img">
                    <p>{{childItem.name}}</p>
                  </div>
                </div>
              </button>
              <button class="deep" @click="detailsJump(item)">查看详情</button>
            </div>
          </div>
          <div class="casesImg" :class="{'pc':item.casesType == 1101}">
            <img :src="item.coverImg">
          </div>
        </div>
      </div>
    </div>
    <section class="partnerBox">
      <ul>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/aliBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/qiniuBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/tencentBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/zbjBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/ztkjBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/epwkBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/eankBlack.png">
        </li>
        <li>
          <img src="https://qn.kemean.cn/upload/201809/06/amerBlack.png">
        </li>
      </ul>
    </section>
    <section class="partnerSaid">
      <!-- 轮播图 -->
      <swiper class="partner-scroll" :options="swiperOption">
        <swiper-slide>
          <p>我决定把项目交付给商鼎云技术，是因为在项目的需求整理和报价的过程中他们团队展示出的专业性，而且市场团队和技术团队非常有耐心的回答了我提出的各种问题。</p>
          <span>合作伙伴如是说</span>
        </swiper-slide>
        <swiper-slide>
          <p>我决定把项目交付给商鼎云技术，是因为在项目的需求整理和报价的过程中他们团队展示出的专业性，而且市场团队和技术团队非常有耐心的回答了我提出的各种问题。</p>
          <span>合作伙伴如是说</span>
        </swiper-slide>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      casesList: [],
      swiperOption: {
        autoplay: 3200,
        setWrapperSize: true,
        observeParents: true,
        loop: true,
        speed: 1000,
        //设置分页
        pagination: ".swiper-pagination",
        //设置分页点击
        paginationClickable: true,
        //设置上一页，下一页
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        autoplayDisableOnInteraction: false
      },
      type: 1000
    };
  },
  created() {
    casesDtata.forEach((item, index) => {
      item.index = index;
    });
    this.casesList = casesDtata;
  },
  methods: {
    detailsJump(item) {
      if (item.casesType == 1101 || item.casesType == 1501) {
        window.open(item.detailsUrl);
      } else {
        this.openJump("/casesDetails/" + item.index);
      }
    },
    getFilter() {
      var casesList = new Array();
      if (this.type == 1000) {
        this.casesList = casesDtata;
      } else {
        casesDtata.forEach(item => {
          if (this.type == item.casesType) {
            casesList.push(item);
          }
        });
        this.casesList = casesList;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
.casesPage {
  background-color: #fff;
}
.banner {
  background-image: url("https://qn.kemean.cn/upload/201809/06/7a4c2eca23b7480fb347d0892d8272af");
}
@media screen and (min-width: 1200px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 80px;
        line-height: 80px;
        border-bottom: 3px solid #fff;
        font-size: 18px;
        color: #666666;
        margin-left: 40px;
        padding: 0px 11px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid $mainColor;
          color: $mainColor;
        }
      }
    }
  }
  .casesListBox {
    .casesList {
      width: 100%;
      background-color: #f8f8f8;
      &:nth-of-type(even) {
        background-color: #ffffff;
        .pageCenter {
          flex-direction: row-reverse;
          .casesImg {
            transform: translateX(-42px);
          }
        }
      }
      &:nth-of-type(odd) {
        .pageCenter {
          .casesImg {
            transform: translateX(42px);
          }
        }
      }
      &.backstage {
        background-image: url("https://qn.kemean.cn/home/case/houtaiguanli.png");
        background-size: auto 100%;
        .casesLogoName .name h3,
        .casesLogoName .name p,
        .description {
          color: #fff !important;
        }
        .but {
          button {
            background-color: #fff !important;
            color: $mainColor !important;
          }
        }
      }
      .pageCenter {
        display: flex;
        justify-content: space-between;
        max-width: 1200px;
        margin: 0 auto;
        .casesInfo {
          padding-top: 80px;
          .casesLogoName {
            display: flex;
            .casesLogo {
              width: 88px;
              height: 88px;
              box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 20px;
              border-radius: 10px;
              img {
                display: block;
                width: 100%;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              h3 {
                font-size: 36px;
                color: #333333;
              }
              p {
                font-size: 24px;
                color: #333333;
              }
            }
            button {
              display: none;
            }
          }
          .description {
            margin-top: 30px;
            width: 450px;
            line-height: 170%;
            font-size: 18px;
            color: #666666;
          }
          .but {
            display: flex;
            margin-top: 50px;
            button {
              width: 170px;
              height: 60px;
              border-radius: 6px;
              font-size: 24px;
              color: #ffffff;
              position: relative;
              &:nth-child(2) {
                margin-left: 20px;
              }
              &.shallow {
                background-color: #529eff;
              }
              &.deep {
                background-color: #345a9e;
              }
              &:hover .code {
                display: flex;
              }
              > .code {
                position: absolute;
                top: 120%;
                background-color: #fff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
                padding: 10px 0 10px 10px;
                border-radius: 7px;
                display: none;
                z-index: 3;
                .arrow,
                .arrow:before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-right: 7px solid transparent;
                  border-left: 7px solid transparent;
                }
                .arrow {
                  left: 78px;
                  top: -7px;
                  border-bottom: 7px solid #ddd;
                }
                .arrow:before {
                  left: 50%;
                  transform: translateX(-50%);
                  top: 1px;
                  border-bottom: 7px solid #fff;
                }
                > div {
                  width: 150px;
                  padding-right: 10px;
                  img {
                    width: 100%;
                    height: 140px;
                  }
                  p {
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
        .casesImg {
          padding-top: 80px;
          height: 542px;
          max-width: 708px;
          flex-shrink: 0;
          overflow-y: hidden;
          &.pc {
            transform: translateX(0px);
          }
          img {
            max-width: 100%;
          }
        }
      }
    }
  }
  .partnerBox {
    max-width: 1200px;
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    padding: 39px 0 9px 0;
    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      li {
        width: 300px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .partnerSaid {
    background-color: #f4f4f4;
    padding: 80px 0;
    .partner-scroll {
      padding-bottom: 40px;
      .swiper-slide {
        display: flex;
        align-items: center;
        flex-direction: column;
        i {
          color: #333333;
          font-size: 60px;
        }
        p {
          font-size: 24px;
          color: #333333;
          text-align: center;
          max-width: 1097px;
          margin-top: 10px;
        }
        span {
          font-size: 30px;
          color: #333333;
          margin-top: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1200px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 80px;
        line-height: 80px;
        border-bottom: 3px solid #fff;
        font-size: 18px;
        color: #666666;
        margin-left: 40px;
        padding: 0px 11px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid $mainColor;
          color: $mainColor;
        }
      }
    }
  }
  .casesListBox {
    .casesList {
      width: 100%;
      background-color: #f8f8f8;
      &:nth-of-type(even) {
        background-color: #ffffff;
        .pageCenter {
          flex-direction: row-reverse;
        }
      }
      &.backstage {
        background-image: url("https://qn.kemean.cn/home/case/houtaiguanli.png");
        background-size: auto 100%;
        .casesLogoName .name h3,
        .casesLogoName .name p,
        .description {
          color: #fff !important;
        }
        .but {
          button {
            background-color: #fff !important;
            color: $mainColor !important;
          }
        }
      }
      .pageCenter {
        display: flex;
        justify-content: space-between;
        .casesInfo {
          padding-top: 5vw;
          padding-left: 3vw;
          .casesLogoName {
            display: flex;
            .casesLogo {
              width: 8vw;
              height: 8vw;
              box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 2vw;
              border-radius: 1vw;
              img {
                width: 100%;
                display: block;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              h3 {
                font-size: 3.4vw;
                color: #333333;
              }
              p {
                font-size: 2.2vw;
                color: #333333;
              }
            }
            button {
              display: none;
            }
          }
          .description {
            margin-top: 3vw;
            width: 40vw;
            line-height: 170%;
            font-size: 1.6vw;
            color: #666666;
          }
          .but {
            display: flex;
            margin-top: 3vw;
            padding-bottom: 3vw;
            button {
              width: 15vw;
              height: 5vw;
              border-radius: 0.6vw;
              font-size: 2.2vw;
              color: #ffffff;
              position: relative;
              &:nth-child(2) {
                margin-left: 2vw;
              }
              &.shallow {
                background-color: #529eff;
              }
              &.deep {
                background-color: #345a9e;
              }
              &:hover .code {
                display: flex;
              }
              > .code {
                position: absolute;
                top: 120%;
                background-color: #fff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
                padding: 1vw 0 1vw 1vw;
                border-radius: 0.7vw;
                display: none;
                z-index: 3;
                .arrow,
                .arrow:before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-right: 7px solid transparent;
                  border-left: 7px solid transparent;
                }
                .arrow {
                  left: 7vw;
                  top: -7px;
                  border-bottom: 7px solid #ddd;
                }
                .arrow:before {
                  left: 50%;
                  transform: translateX(-50%);
                  top: 1px;
                  border-bottom: 7px solid #fff;
                }
                > div {
                  width: 150px;
                  padding-right: 10px;
                  img {
                    width: 100%;
                    height: 140px;
                  }
                  p {
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
        .casesImg {
          padding-top: 5vw;
          width: 50vw;
          flex-shrink: 0;
          overflow-y: hidden;
          display: flex;
          align-items: flex-end;
          &.pc {
            padding-left: 3vw;
            padding-bottom: 3vw;
          }
          img {
            max-width: 100%;
          }
        }
      }
    }
  }
  .partnerBox {
    max-width: 1200px;
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    padding: 39px 0 9px 0;
    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      li {
        width: 300px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .partnerSaid {
    background-color: #f4f4f4;
    padding: 80px 0;
    .partner-scroll {
      padding-bottom: 40px;
      .swiper-slide {
        display: flex;
        align-items: center;
        flex-direction: column;
        i {
          color: #333333;
          font-size: 60px;
        }
        p {
          font-size: 24px;
          color: #333333;
          text-align: center;
          max-width: 1097px;
          margin-top: 10px;
        }
        span {
          font-size: 30px;
          color: #333333;
          margin-top: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 12vw;
        line-height: 12vw;
        border-bottom: 3px solid #fff;
        font-size: 4.2vw;
        color: #666666;
        margin-left: 7vw;
        padding: 0px 2vw;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid $mainColor;
          color: $mainColor;
        }
      }
    }
  }
  .casesListBox {
    .casesList {
      width: 100%;
      background-color: #eee;
      // background-color: #f8f8f8;
      // padding-bottom: 10vw;
      // &:nth-of-type(even) {
      //   background-color: #ffffff;
      //   .pageCenter {
      //     flex-direction: row-reverse;
      //   }
      // }
      &.backstage {
        background-image: url("https://qn.kemean.cn/home/case/houtaiguanli.png");
        background-size: 100% 100%;
        background-position: 0 0;
        background-repeat: no-repeat;
        .casesLogoName .name h3,
        .casesLogoName .name p,
        .description {
          color: #fff !important;
        }
        .casesInfo {
          background-color: transparent !important;
        }
        .but {
          button {
            background-color: #fff !important;
            color: $mainColor !important;
          }
        }
      }
      .pageCenter {
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        flex-direction: column-reverse;
        .casesInfo {
          padding-top: 3vw;
          padding-left: 3vw;
          padding-right: 3vw;
          background-color: #fff;
          padding-bottom: 5vw;
          display: flex;
          flex-direction: column-reverse;
          box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
          .casesLogoName {
            margin-top: 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .casesLogo {
              width: 16vw;
              height: 16vw;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 2vw;
              border-radius: 1vw;
              img {
                width: 100%;
                display: block;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              width: calc(100% - 45vw);
              h3 {
                font-size: 5.2vw;
                color: #333333;
              }
              p {
                font-size: 3.6vw;
                color: #333333;
              }
            }
            button {
              width: 24vw;
              height: 9vw;
              border-radius: 1vw;
              font-size: 4vw;
              color: #ffffff;
              background-color: #345a9e;
            }
          }
          .description {
            line-height: 170%;
            font-size: 3.6vw;
            color: #666666;
          }
          .but {
            display: none;
          }
        }
        .casesImg {
          padding-top: 12vw;
          width: 100%;
          flex-shrink: 0;
          overflow-y: hidden;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          // &.pc img {
          //   max-height: 100%;
          //   max-width: initial;
          // }
          img {
            max-width: 100%;
          }
        }
      }
    }
  }
  .partnerBox {
    width: 100%;
    padding: 4vw 2vw 1vw 2vw;
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 49%;
        height: 22vw;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5vw;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .partnerSaid {
    background-color: #f4f4f4;
    padding: 8vw 0;
    .partner-scroll {
      padding-bottom: 40px;
      .swiper-slide {
        display: flex;
        align-items: center;
        flex-direction: column;
        i {
          color: #333333;
          font-size: 8vw;
        }
        p {
          font-size: 3.6vw;
          color: #333333;
          text-align: center;
          padding: 0px 2vw;
          margin-top: 1vw;
        }
        span {
          font-size: 3.6vw;
          color: #333333;
          margin-top: 2vw;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
